module.exports = __webpack_public_path__ + "img/ic-about.f0cea2fd.svg";